import { useIframeableContext } from 'payments-checkout-lib/context/IframeableContext';
export function useCheckoutIframeableContext() {
  return useIframeableContext();
}